var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"circle-Loading"},[_c('fulfilling-bouncing-circle-spinner',{attrs:{"animation-duration":2000,"size":80,"color":"#0080FC"}}),_vm._v(" "),_c('span',{staticClass:"loading-wait"},[_vm._v(_vm._s(_vm.view.translations.label_loading_v5)+"...")])],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36fa04e0","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/office/js/components/login-v5/spinners/CircleSpinner.vue
// module id = 63oB
// module chunks = 0